import React from "react";
import { Link } from "react-router-dom";

// Constants
const AOS_CONFIG = {
  fadeUp: { "data-aos": "fade-up", "data-aos-duration": "4000" },
  fadeUpDelayed: { "data-aos": "fade-up", "data-aos-duration": "4000", "data-aos-delay": "200" },
  fadeRight: { "data-aos": "fade-right", "data-aos-duration": "4000" },
};

const CAPITAL_INFO = {
  authorized: "Rs. 2.5 billion",
  authorizedFormatted: "Rs. 2.5 Billion",
  paidUp: "Rs. 2.28 billion",
  paidUpFormatted: "Rs. 2.28 Billion",
  description: "The company was incorporated in June, 2006 with its registered head-office in Karachi. The authorized capital of the Company is",
  descriptionEnd: "The issued, subscribed and paid-up capital of the company as of December 31st 2025 is",
};

const SHAREHOLDERS = [
  "Mr. Salim Habib Godil",
  "Mr. Rizwan Hussain",
  "Mr. Shahzad Salim Godil",
  "Syed Salman Hussain",
  "House Building Finance Company Limited",
  "Al Baraka Bank (Pakistan) Limited",
  "Mal Al-Khaleej Investment LLC (UAE)",
];

const SHAREHOLDING_PATTERN = {
  title: "Salaam Takaful Shareholding Pattern",
  pdfPath: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/PatternofShareholding.pdf`,
  date: "31 Dec, 2025",
};

// SVG Icons Components
const CapitalIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ShareholdersIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function Capitals() {
  return (
    <>
      <div className="container-fluid shares">
        <div className="row">
          <div className="col-sm-12 capitals-content">
            {/* Paid Up Capital Card - Redesigned */}
            <div className="capital-card" {...AOS_CONFIG.fadeUp}>
              <div className="capital-header">
                <div className="capital-icon">
                  <CapitalIcon />
                </div>
                <h2 className="capital-title">Paid up Capital</h2>
              </div>
              <div className="capital-body">
                <p className="capital-description">
                  {CAPITAL_INFO.description}{" "}
                  <span className="highlight">{CAPITAL_INFO.authorized}</span>.{" "}
                  {CAPITAL_INFO.descriptionEnd}{" "}
                  <span className="highlight">{CAPITAL_INFO.paidUp}</span>.
                </p>
                
                {/* Enhanced Stats Display */}
                <div className="capital-stats-wrapper">
                  <div className="capital-stats">
                    <div className="stat-card stat-card-authorized">
                      <div className="stat-icon-wrapper">
                        <div className="stat-icon">PKR</div>
                      </div>
                      <div className="stat-content">
                        <div className="stat-label">Authorized Capital</div>
                        <div className="stat-value">{CAPITAL_INFO.authorizedFormatted}</div>
                      </div>
                    </div>
                    
                    <div className="stat-divider-vertical"></div>
                    
                    <div className="stat-card stat-card-paidup">
                      <div className="stat-icon-wrapper">
                        <div className="stat-icon">✓</div>
                      </div>
                      <div className="stat-content">
                        <div className="stat-label">Paid-up Capital</div>
                        <div className="stat-value">{CAPITAL_INFO.paidUpFormatted}</div>
                        <div className="stat-subtitle">As of Dec 31, 2025</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Shareholders Card */}
            <div className="shareholders-card" {...AOS_CONFIG.fadeUpDelayed}>
              <div className="shareholders-header">
                <div className="shareholders-icon">
                  <ShareholdersIcon />
                </div>
                <h2 className="shareholders-title">Shareholders</h2>
              </div>
              <div className="shareholders-list">
                {SHAREHOLDERS.map((shareholder, index) => (
                  <div key={index} className="shareholder-item">
                    <div className="shareholder-badge"></div>
                    <span className="shareholder-name">{shareholder}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-sm-12 shareholding">
        <h2 {...AOS_CONFIG.fadeRight}>{SHAREHOLDING_PATTERN.title}</h2>
        <p {...AOS_CONFIG.fadeRight}>
          <Link to={SHAREHOLDING_PATTERN.pdfPath} target="_blank" rel="noopener noreferrer">
            View Here
          </Link>{" "}
          Date: {SHAREHOLDING_PATTERN.date}.
        </p>
      </div>
    </>
  );
}

export default Capitals;
